import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@mui/material";
import { useState } from "react";
import DownloadIcon from "@mui/icons-material/Download";
import { downloadFile } from "../../utils/file";
import { useStoreFileViewerContext } from "../../hooks/context";
import { parseErrorFromPangea } from "../../utils";
var DownloadFileButton = function (_a) {
    var object = _a.object, ButtonProps = _a.ButtonProps;
    var apiRef = useStoreFileViewerContext().apiRef;
    var _b = useState(false), downloading = _b[0], setDownloading = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var handleDownloadFile = function () {
        if (downloading)
            return;
        setDownloading(true);
        return downloadFile(object, apiRef)
            .then(function () {
            setDownloading(false);
            setError(null);
        })
            .catch(function (err) {
            setError(parseErrorFromPangea(err));
            setDownloading(false);
        });
    };
    return (_jsx(Button, __assign({ variant: "text", sx: { width: "100%" } }, ButtonProps, { startIcon: _jsx(DownloadIcon, { fontSize: "small" }), disabled: downloading, onClick: handleDownloadFile, fullWidth: true, children: downloading ? "Downloading..." : "Download" })));
};
export default DownloadFileButton;
